module.exports = __webpack_public_path__ + "2ecae1fa8067a7fd5875aec69eedc16e.svg";